<script>
export default {
	props: {
		message: String,
	},
};
</script>

<template>
	<div class="loader-container">
		<p style="text-align: center; margin-bottom: 16px">
			<span style="color: black">{{ message }}</span>
			<span class="dot-one">.</span>
			<span class="dot-two">.</span>
			<span class="dot-three">.</span>
			<span>🙏</span>
		</p>
		<span class="loader"></span>
	</div>
</template>

<style scoped>
.loader-container {
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 100%;
	padding: 16px;
	align-items: center;
	justify-content: center;
}

.loader {
	border: 5px solid black;
	border-radius: 50%;
	height: 48px;
	width: 48px;
	border-bottom-color: transparent;
	display: inline-block;
	box-sizing: border-box;
	animation: rotation 1s linear infinite;
}

@keyframes rotation {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

span[class^="dot-"] {
	opacity: 0;
}

.dot-one {
	animation: dot-one 2s infinite linear;
}

.dot-two {
	animation: dot-two 2s infinite linear;
}

.dot-three {
	animation: dot-three 2s infinite linear;
}

@keyframes dot-one {
	0% {
		opacity: 0;
	}
	15% {
		opacity: 0;
	}
	25% {
		opacity: 1;
	}
	100% {
		opacity: 1;
	}
}

@keyframes dot-two {
	0% {
		opacity: 0;
	}
	25% {
		opacity: 0;
	}
	50% {
		opacity: 1;
	}
	100% {
		opacity: 1;
	}
}

@keyframes dot-three {
	0% {
		opacity: 0;
	}
	50% {
		opacity: 0;
	}
	75% {
		opacity: 1;
	}
	100% {
		opacity: 1;
	}
}
</style>
